import {useEffect} from "react";

// Every page has its own background mood (see "Page backgrounds" in index.css).
// Themes: "park" (lobby), "game", "study" (analysis), "golden" (leaderboards - the statue plaza at dusk),
// "blossom" (profiles - the cherry trees), "lake" (social and messages)
const usePageTheme = (theme) => {
    useEffect(() => {
        if (!theme) return;
        document.body.dataset.theme = theme;
        return () => {
            if (document.body.dataset.theme === theme) delete document.body.dataset.theme;
        };
    }, [theme]);
};

export default usePageTheme;
